import { Typography } from '@fullscreendigital/carrefour-dex-fe'
import { URLS } from '../../../../constants'
import { generatePath, useNavigate, useParams } from "react-router-dom"
import { TitleHeader } from '../../../../Common/TitleHeader'
import { makeCoreGetRequest } from "../../../../../../../utils/api"
import { formatErrorMessage } from '../../../../../../../utils/formatting'
import { useNotification } from '../../../../../../../hooks'
import { useQuery } from 'react-query'
import { CircularProgress, Container, Paper } from "@mui/material"
import { Grid } from '@mui/material'

const RayonList = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { showNotification } = useNotification()

  const supplierCode = id ? Number(id) : undefined
  const { data: rayonList, isLoading } = useQuery(
    ['rayonList', id],
    async () => {
      return await makeCoreGetRequest(`/shop-reception-mobile/ds-rayon/list/${supplierCode}`, null)
    },
    {
      enabled: !!supplierCode,
      onError: error => {
        showNotification({
          message: `Error while fetching raions. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  if (isLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Container maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title="Selecteazǎ Raion" />
        </Grid>
        <Grid item xs={12}>
          <Container maxWidth="xs">
            <Grid container spacing={1}>
              {rayonList?.map((rayon: any) => (
                <Grid item xs={12} key={rayon.rayonCode}>
                  <Paper
                    elevation={3}
                    style={{ margin: '10px', padding: '20px', cursor: 'pointer' }}
                    onClick={() => {
                      navigate(generatePath(URLS.AUTH_SUPPLIERS_ORDER_LIST, { id }) + `?rayonCode=${rayon.rayonCode}`)
                    }}
                  >
                    <Typography variant="medium" component="h5">
                      {rayon.rayonCode}
                    </Typography>
                    <Typography variant="medium" component="p">
                      {rayon.rayonName}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Container>
  )
}

export default RayonList
